// -*- Mode: rjsx -*-
import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import LoopIcon from '@mui/icons-material/Loop';
import Avatar from '@mui/material/Avatar';

import Skeleton from 'react-loading-skeleton';
import Tooltip from '@mui/material/Tooltip';

import { apiDoClaim } from '..';
import { setCurrentRequest, CARD_TITLE_PROPS } from '../../request';
import { fetchHistory } from '../../history';

import { FHMaterialStyles } from "../../../ui/fh-material-styles.js";

import { Success, Error } from '../../../ui';

function ClaimAvatar(props) {
    let user = props.user;
    let avatar_url = user.avatar_url || "";
    if (avatar_url.indexOf('/') === 0)
        avatar_url = 'https://www.fancyhands.com' + avatar_url;

    return (user.key ?
            <Avatar src={avatar_url} /> :
            <Skeleton width={48} height={48} />);
    
}

function ClaimStatus(props) {
    const classes = FHMaterialStyles();
    let user = props.user;
    
    return (
        <Card>
          <CardHeader
            titleTypographyProps={CARD_TITLE_PROPS}
            gutterBottom
            title="Claimed By"
          />

          <CardContent>          
          <Grid container spacing={1}>
            <Grid item>
              <ClaimAvatar user={user} />
            </Grid>
            <Grid item>
              <Typography gutterBottom variant="subtitle">
                { user.name || <Skeleton width={100} />} 
              </Typography>
              <Typography gutterBottom variant="body2" color="textSecondary">
                { user.type || <Skeleton width={75} /> } 
              </Typography>              
            </Grid>            
          </Grid>
        </CardContent>
        </Card>
    );

}


function ClaimButton(props) {
    if(props.claiming)
        return <LoopIcon />;

    else {
        return (
            <Tooltip title="Claim this and it's all yours!" arrow={true}>
              <Button onClick={props.onClick} variant="contained" color="primary" align="center">
                Claim This
              </Button>
            </Tooltip>
        );
    }

}
function ClaimNow(props) {
    const classes = FHMaterialStyles();

    const claiming = useSelector(state => state.claim.claiming);

    let title = "This request is available";
    if(claiming)
        title = "Claiming now...";
    
    return (
        <Card>
          
          <CardHeader
            title={title}
            titleTypographyProps={CARD_TITLE_PROPS}
            gutterBottom />
          
          <CardContent>
            <Box align="center">
              <ClaimButton onClick={props.doClaim} claiming={claiming} />
            </Box>
          </CardContent>

        </Card>
    );

}


function Claim(props) {
    let request = props.request;
    let claimed_by = request.claimed_by;
    const dispatch = useDispatch();
    const user = useSelector(state => state.hud.user);
    
    let [claimed, setClaimed] = useState(false);
    let [error, setError] = useState(false);


    function doClaim(e) {

        e.preventDefault();
  
        // fixme: this should come from react? 
        dispatch(
            apiDoClaim(
                {
                    requestKey: request.key,
                    userKey: user.key
                }
            )
        ).then((data) => {
            if(data.type.endsWith("fulfilled")) {
                setClaimed(true);
                dispatch(setCurrentRequest(data.payload));
                dispatch(fetchHistory({key: data.payload.key }));
            }
            else {
                setError(true);
                console.error("Something went wrong? %o", data);
            }
        }).catch((data) => {
            setError(true);            
            console.error("ok %o", data);
        });
        
    }


    function onClose() {
        setClaimed(false);
        setError(false);        
    }
    
    return (
        <div>

          { claimed_by ? <ClaimStatus user={claimed_by} /> : <ClaimNow doClaim={doClaim} />  }
          
          <Success open={claimed} onClose={onClose}>Great! You've claimed this request!</Success>
          <Error open={error} onClose={onClose}>Unable to claim this request!</Error>
        </div>
    );
    
}

export default Claim;
